import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class HelperTransalaterService {
   constructor(private translate: TranslateService) { }

   getSingleTranslation(single: string): string {
      let _text: string;
      this.translate.get(single).subscribe(result => _text = result);
      return _text;
   }

   getTagEform(target: string) {
      return this.getSingleTranslation(`eform.${target}`);
   }

   getMultipleTranslation(multiple: Array<string>): Array<string> {
      const _text = [];
      try {
         multiple.forEach(translation => {
            _text.push(this.getSingleTranslation(translation));
         });
         return _text;
      } catch {
         throw new Error('Error: unexpected Translators or Can not found that');
      }
   }



}
